function isTierAvailable(tier) {
  const currentDate = new Date();

  if (tier.startDate) {
    if (tier.endDate) {
      return (
        currentDate >= new Date(tier.startDate) &&
        currentDate <= new Date(tier.endDate)
      );
    }
    return currentDate >= new Date(tier.startDate);
  }

  // If no dates specified, return true
  return true;
}

export default isTierAvailable;
